<template>
  <div class="sa-selc-test">
    <div>
      <span class="sa-gray-text">{{tests.selectedLabel}}</span>
      <span class="sa-d-block">{{tests.numberOfTest}}</span>
    </div>
    <div>
      <span class="sa-d-i-block" v-if="$route.path == '/lab-appointments'">Tube: <small
          class="sa-tube sa-tube-red"></small><small class="sa-tube"></small><small
          class="sa-tube sa-tube-blue"></small></span>
      <span class="sa-d-block sa-secondary-text sa-link sa-text-right sa-cursor" @click="viewDetails()">View details</span>
    </div>
    <ViewDetails v-if="showDetails" @close-pop="closePop" :type="tests.type" :servId="tests.srvc_id"/>
  </div>
</template>
<script>
import ViewDetails from "./ViewDetails.vue";
export default {
  props: ['tests'],
  components: { ViewDetails },
  data() {
    return {
      showDetails: false,
    };
  },
  methods: {
    viewDetails() {
      this.showDetails = true;
    },
    closePop() {
      this.showDetails = false;
    },
  },
};
</script>
